import { useSelector } from 'react-redux';

import { State } from 'store/main';

export function useGMapsErrored(): boolean {
  return useSelector((state: State) => state.gMapsError.errored);
}
